<p-chip class="!py-0 !pl-1 !pr-1 !gap-1  shadow-light-md ">
  <span class="ml-1 text-xs text-ebony-900 dark:text-white">
        {{ label }}
    </span>
  <ng-container
    *ngIf="toBoolean(checked); then ischecked; else unchecked">
  </ng-container>
  <ng-template #ischecked>
      <span class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center ">
        <img src="/svg/test-results/checked.svg" alt="Checked"/>
    </span>

  </ng-template>
  <ng-template #unchecked>
    <span class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center ">
        <img src="/svg/test-results/unchecked.svg" alt="Not Checked"/>
    </span>
  </ng-template>
</p-chip>
